"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderSummaryDriverDetails = void 0;
const React = require("react");
const SlimSection_1 = require("../../../../../../components/base/structure/SlimSection");
const useConfig_1 = require("../../../../../../hooks/useConfig");
const Img_1 = require("../../../../../../components/base/atoms/Img");
const useSalesOrderDetailsForStatus_1 = require("../../../hooks/useSalesOrderDetailsForStatus");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const formatPhoneNumber_1 = require("../../../../../../helpers/formatPhoneNumber");
const constants_1 = require("../../../helpers/constants");
const css = (0, cssComposer_1.default)(styles, "SalesOrderSummaryDriverDetails");
const SalesOrderSummaryDriverDetails = ({ salesOrder, type, children }) => {
    var _a, _b;
    const { isDoorDashDelivery, completed } = salesOrder;
    const { brandLogoSmall } = (0, useConfig_1.useConfig)();
    const baseDeliveryText = constants_1.text[constants_1.TTheme.Zam][constants_1.TOrderingText.Delivery];
    const deliveryPartnerPhoneNumber = (_b = (_a = salesOrder.deliveryDriver) === null || _a === void 0 ? void 0 : _a.supportPhoneNumber) !== null && _b !== void 0 ? _b : salesOrder === null || salesOrder === void 0 ? void 0 : salesOrder.deliveryPartnerSupportPhoneNumber;
    let { deliveryDriverStatusText } = (0, useSalesOrderDetailsForStatus_1.useSalesOrderDetailsForStatus)(salesOrder);
    // replace "{tracking_link}" to add an HTML anchor link
    const deliveryAssignedText = baseDeliveryText[constants_1.TDeliveryText.DeliveryPartnerAssigned];
    const isDeliverDriverAssignedText = deliveryDriverStatusText === deliveryAssignedText;
    if (isDeliverDriverAssignedText) {
        const trackingLink = `<strong><a href=${salesOrder === null || salesOrder === void 0 ? void 0 : salesOrder.externalDeliveryTrackingUrl} target="_blank">Tracking Link</a></strong>.`;
        deliveryDriverStatusText = deliveryAssignedText === null || deliveryAssignedText === void 0 ? void 0 : deliveryAssignedText.replace("{tracking_link}", trackingLink);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(SlimSection_1.SlimSection, { className: css("", {
                ["-isDesktop"]: type === "desktop",
                ["-isMobile"]: type === "mobile"
            }) },
            type === "desktop" &&
                completed === false &&
                isDeliverDriverAssignedText && (React.createElement(SlimSection_1.SlimSectionHeader, null,
                React.createElement(SlimSection_1.SlimSectionTitle, null, "Delivery partner on the way"))),
            React.createElement(SlimSection_1.SlimSectionBody, null,
                React.createElement("div", { className: css("details") },
                    React.createElement(Img_1.Img, { className: css("details_image"), src: brandLogoSmall }),
                    React.createElement("span", { className: css("details_status"), dangerouslySetInnerHTML: { __html: deliveryDriverStatusText } }),
                    children)),
            deliveryPartnerPhoneNumber && (React.createElement(SlimSection_1.SlimSectionBody, null,
                React.createElement("div", { className: css("details") },
                    React.createElement("div", { className: css("phoneNumber_text") },
                        React.createElement("div", { className: css("line_name") }, "Contact Delivery Partner Support"),
                        React.createElement("a", { href: `tel:${deliveryPartnerPhoneNumber}`, title: "Delivery Partner Support" }, (0, formatPhoneNumber_1.formatPhoneNumber)(deliveryPartnerPhoneNumber)))))),
            isDoorDashDelivery && completed === false && (React.createElement(SlimSection_1.SlimSectionBody, null,
                React.createElement("div", { className: css("details") },
                    React.createElement("div", { className: css("section_text") },
                        React.createElement("em", null,
                            "This order will be delivered to you by our",
                            " ",
                            React.createElement("strong", null, "DoorDash"),
                            " partner."))))))));
};
exports.SalesOrderSummaryDriverDetails = SalesOrderSummaryDriverDetails;
//# sourceMappingURL=index.js.map